import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import SignInForm from "./SignInForm";
import { useSelector, useDispatch } from "react-redux";
import {
  selectUser,
  toggleLoginDialog,
  toggleRegisterDialog,
} from "../../Store/Slices/userSlice";

import {
  useDeleteCartItemMutation,
  useGetCartIdforUserMutation,
  useLazyGetAllCartItemsQuery,
} from "../../Store/Services/CartService";
import { useNavigate } from "react-router-dom";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { clearGlobalCartId } from "../../Utils/cartSession";
import styles from "../../Styles/util.module.css";

const SignInDialog = () => {
  const { isLoginDialogOpen } = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClose = () => {
    dispatch(toggleLoginDialog());
  };

  const handleCreateAccountClick = () => {
    handleClose();
    dispatch(toggleRegisterDialog());
  };

  const handleForgotPasswordClick = () => {
    handleClose();
    navigate("/forgot-password");
  };

  const [getUserCartId] = useGetCartIdforUserMutation();
  const [fetchCartItems] = useLazyGetAllCartItemsQuery();
  const [deleteCartItem] = useDeleteCartItemMutation();

  const clearCartItems = async (cartId) => {
    if (!cartId) {
      return;
    }
    try {
      const response = await fetchCartItems(cartId).unwrap();
      const items = response?.orderDetails?.items || [];
      await Promise.all(
        items.map((item) =>
          deleteCartItem(item?.orderDetId)
            .unwrap()
            .catch(() => null)
        )
      );
    } catch {
      // Continue with a fresh local sale even if server cart fetch fails.
    }
  };

  const handleSuccess = () => {
    const dataSet = { orderHeadId: 0, orderType: 2 };

    // Run cart cleanup in background so login redirect isn't blocked by slow APIs.
    (async () => {
      try {
        const userCartId = await getUserCartId(dataSet).unwrap();
        const openCartId = userCartId?.orderHeaderId
          ? String(userCartId.orderHeaderId)
          : null;

        await clearCartItems(openCartId);
      } catch (err) {
        console.error("Background cart cleanup failed:", err);
      } finally {
        clearGlobalCartId();
        window.dispatchEvent(
          new CustomEvent("pos:cart-id-changed", {
            detail: { cartId: null },
          })
        );
      }
    })();
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"500px"}
      style={{ padding: "1rem" }}
      open={isLoginDialogOpen}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "500px",
            minWidth: "300px",
          },
        },
      }}
    >
      <DialogTitle style={{ textAlign: "center" }}>
        Sign In
        <Button
          onClick={handleClose}
          style={{ position: "absolute", right: "8px", top: "8px" }}
          aria-label="Sign In"
        >
          <CloseIcon />
        </Button>
      </DialogTitle>
      <DialogContent>
        <SignInForm onSuccess={handleSuccess} />
        {/* <Button
          className={styles.formItem}
          color="secondary"
          fullWidth
          onClick={handleCreateAccountClick}
          aria-label="Create an Account"
        >
          Create an Account
        </Button> */}
        <Divider>OR</Divider>
        <Button
          className={styles.formItem}
          color="secondary"
          fullWidth
          onClick={handleForgotPasswordClick}
          aria-label="Forgot Password?"
        >
          Forgot Password?
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SignInDialog;
